import React, { useEffect, useState } from 'react';

import './styles.css';

import close from '../../../assets/images/close.svg';
import check from '../../../assets/images/check.svg';
import { Row, Col } from 'react-bootstrap';

import LoadingComponent from '../../LoadingComponent';

import api from '../../../services/api';

export const ModalShiftTotal = ({ handleClose, handleShift, shifts, region = null, isUnique = false }) => {
  const [regionais, setRegionais] = useState([]);
  const [plantoes, setPlantoes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getRegionais();
  }, []);
  useEffect(() => {
    setPlantoes(shifts);
  }, [shifts]);

  const getRegionais = async () => {
    const { data } = await api.get(`list-plantoes`);
    if (data) {
      setLoading(false);
      setRegionais(data.regionais);
    }
  }

  const handlePlantoes = (e, plantao) => {
    if (plantoes.includes(plantao)) {
      if (isUnique) {
        setPlantoes([]);
      } else {
        let filtered = plantoes.filter(value => value !== plantao);
        setPlantoes(filtered);
      }
    } else {
      if (isUnique) {
        setPlantoes([plantao]);
      } else {
        setPlantoes([...plantoes, plantao]);
      }

    }
  }

  const handleCheckAll = (e, regional) => {
    let current = checkAll(regional);
    e.preventDefault();
    let toSet = [...plantoes];
    regional.plantoes.map(p => {
      if (current) {
        let index = toSet.indexOf(p.id);
        if (index > -1) {
          toSet.splice(index, 1);
        }
      } else {
        if (!toSet.includes(p.id)) {
          toSet.push(p.id);
        }
      }
    });
    setPlantoes(toSet);
  }

  const checkAll = (regional) => {
    let allPlantoes = regional.plantoes;
    let allIds = allPlantoes.map(p => p.id);
    let result = true;
    allIds.map(id => {
      result = result ? plantoes.includes(id) : false;
    });
    return result;
  }

  return (
    <div className="dash-modal">
      <div className="dash-modal-content lg">
        <button className="btn-close" onClick={() => handleClose()}><img src={close} /></button>
        <div className="dash-modal-header">
          <h2>Selecione um ou mais plantões</h2>
        </div>
        <div className="dash-modal-body">
          {!loading &&

            <div className="shifts">
              {regionais.map((regional, key) => (
                <div className={`shifts-region ${!region?.id || region?.id === regional.id ? '' : 'hide'}`} key={key}>
                  <div className="shifts-title-region">
                    <h3>{regional.nome}</h3>
                    {/* <a href="#" onClick={e => handleCheckAll(e, regional)}>selecionar todos</a> */}
                  </div>
                  <hr />
                  <Row>
                    <Col sm={12}>
                      {!isUnique &&
                        regional.plantoes.length > 0 &&
                        <button className={`btn-shift selectall ${checkAll(regional) ? 'active' : ''}`} onClick={e => handleCheckAll(e, regional)}>
                          <div className="check-shift">
                            <div className="checked-shift">
                              {checkAll(regional) &&
                                < img src={check} />
                              }
                            </div>
                          </div>
                          <span>Selecionar todos</span>
                        </button>
                      }

                      {regional.plantoes.map((plantao, pKey) => (
                        <button className={`btn-shift ${plantoes.includes(plantao.id) ? 'active' : ''}`} key={pKey} onClick={(e) => handlePlantoes(e, plantao.id)}>
                          <div className="check-shift">
                            <div className="checked-shift">
                              {plantoes.includes(plantao.id) &&
                                < img src={check} />
                              }
                            </div>
                          </div>
                          <span>{plantao.imovel_nome}</span>
                        </button>
                      ))}
                    </Col>
                  </Row>
                </div>
              ))}

            </div>
          }
          <LoadingComponent loading={loading} />
        </div>
        <div className="dash-modal-footer">
          <button className="btn-save-shifts" onClick={() => {
            const allShiftIds = regionais.flatMap(r => r.plantoes.map(p => p.id));
            handleShift(plantoes, allShiftIds);
            handleClose();
          }}>Ok</button>
        </div>
      </div>
    </div>
  );

}

export default ModalShiftTotal;